// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2JRTP","ranges":"BmiRanges_ranges__1uthg"};